import React, { useEffect, useRef, useState } from "react";
import ImageWithBasePath from "../../../core/img/imagewithbasebath";
import { OverlayTrigger } from "react-bootstrap";
import { Link } from "react-router-dom";
import {
  ChevronUp,
  File,
  Filter,
  Sliders,
  Archive,
  User,
  Calendar,
  Layers,
  RotateCcw,
} from "feather-icons-react/build/IconComponents";
import Select from "react-select";
import { renderTooltip } from "../../../redux/helper";
import { Table, Checkbox, DatePicker } from "antd";
import { setheadertoggle } from "../../../redux/toggle";
import { useDispatch, useSelector } from "react-redux";
import { getVoidLogReport } from "../../../services/ReportApiService";
import {
  DatatablePagingParameter,
  Filterclass,
} from "../../../core/json/DatatablePagingParameters";
import dayjs from "dayjs";
import {
  fetchCounter,
  fetchSection,
  fetchProduct,
  fetchSettings,
} from "../../../redux/userSetting";
import { fetchUser } from "../../../redux/userServices";
import { fetchCompanyDetail } from "../../../redux/companyDetail";
import {
  exportreportExcel,
  exportreportPDF,
  printreportReport,
} from "../../../core/utils/MainReportUtils";
import LoadingUtils from "../../../core/utils/LoadingUtils";

const VoidReport = () => {
  const [searchText, setSearchText] = useState("");
  const [voidData, setVoidData] = useState([]);
  const [allData, setAllData] = useState([]);
  const [footerTotal, setFooterTotal] = useState({});
  const [isFilterVisible, setIsFilterVisible] = useState(false);
  const [loading, setloading] = useState(false);
  const [fromDate, setFromDate] = useState(dayjs());
  const [toDate, setToDate] = useState(dayjs());
  const [totalcount, settotalcount] = useState(0);
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(20);
  const [sectionval, setsectionval] = useState(null);
  const [counterval, setcounterval] = useState(null);
  const [productval, setproductval] = useState(null);
  const [userval, setuserval] = useState(null);

  const dispatch = useDispatch();
  const tableRef = useRef(null);
  const { branch } = useSelector((state) => state.branchlist);
  const { togglehead } = useSelector((state) => state.headerToggle);
  const { counterList, sectionList, productList } = useSelector(
    (state) => state.usersetting
  );
  const { UserList } = useSelector((state) => state.userservice);
  const { companyInfolist } = useSelector((state) => state.companyInfo);
  const currfmt = useSelector((state) => {
    const match = state.usersetting?.settingList?.currencyFormat
      ?.toString()
      ?.match(/\.0+/);
    return match ? match[0]?.length - 1 : 0;
  });

  useEffect(() => {
    if (!branch?.guid) return;
    dispatch(fetchSection(branch.guid));
    dispatch(fetchCounter(branch.guid));
    dispatch(fetchProduct(branch));
    dispatch(fetchUser());
    dispatch(fetchCompanyDetail());
    dispatch(fetchSettings(branch));
  }, [branch]);

  useEffect(() => {
    handlegetVoidReport(currentPage, pageSize);
    handlegetVoidfullReport();
  }, [branch, fromDate, toDate]);

  // Filters are applied server-side - the VoidLogReport endpoint accepts every
  // field below, so the grid always shows a correctly paged, filtered set.
  const buildFilters = () => {
    const Filters = new Filterclass();
    Filters.Branch = branch;
    Filters.FromDate = dayjs(fromDate).format("YYYY-MM-DD");
    Filters.ToDate = dayjs(toDate).format("YYYY-MM-DD");
    Filters.Section = sectionval?.value ?? "";
    Filters.Counter = counterval?.value ?? "";
    Filters.Product = productval?.value ?? "";
    Filters.User = userval?.value ?? "";
    return Filters;
  };

  const handlegetVoidReport = async (page, size) => {
    const DatatablePagingParameters = new DatatablePagingParameter();
    DatatablePagingParameters.PageNumber = page;
    DatatablePagingParameters.PageSize = size;
    try {
      const response = await getVoidLogReport({
        DatatablePagingParameters,
        Filters: buildFilters(),
      });
      const detail = response?.data?.voidLogReportDetail ?? [];
      setVoidData(detail);
      settotalcount(detail[0]?.recordsFilteredCount ?? 0);
      setFooterTotal(response?.data?.footerTotal ?? {});
    } catch (error) {
      console.error(
        "Error Fetching Void Report!",
        error?.response?.data?.Message
      );
    }
  };

  // Unpaged copy of the same filtered set, used only by export / print.
  const handlegetVoidfullReport = async () => {
    setloading(true);
    const DatatablePagingParameters = new DatatablePagingParameter();
    DatatablePagingParameters.PageNumber = 1;
    DatatablePagingParameters.PageSize = -1;
    try {
      const response = await getVoidLogReport({
        DatatablePagingParameters,
        Filters: buildFilters(),
      });
      setAllData(response?.data?.voidLogReportDetail ?? []);
      setloading(false);
    } catch (error) {
      setloading(false);
      console.error(
        "Error Fetching Void Report!",
        error?.response?.data?.Message
      );
    }
  };

  const handleSearch = (e) => {
    setSearchText(e.target.value);
  };
  const toggleFilterVisibility = () => {
    setIsFilterVisible((prevVisibility) => !prevVisibility);
  };
  const handletogglehead = () => {
    dispatch(setheadertoggle(!togglehead));
  };
  const handleFromDateChange = (date) => {
    setFromDate(date);
    setToDate(null);
  };
  const handleToDateChange = (date) => {
    setToDate(date);
  };

  const section = sectionList?.map((e) => ({ value: e.guid, label: e.name }));
  const counter = counterList?.map((e) => ({ value: e.guid, label: e.name }));
  const product = productList?.map((e) => ({ value: e.guid, label: e.name }));
  const users = UserList?.map((e) => ({ value: e.guid, label: e.name }));

  const menuItems = [
    { value: "1", label: "Bill No", checked: true },
    { value: "2", label: "Voided Date", checked: true },
    { value: "3", label: "Product", checked: true },
    { value: "4", label: "Quantity", checked: true },
    { value: "5", label: "Rate", checked: true },
    { value: "6", label: "Reason", checked: true },
    { value: "7", label: "Voided By", checked: true },
    { value: "8", label: "Section", checked: true },
    { value: "9", label: "Counter", checked: false },
    { value: "10", label: "Branch", checked: false },
  ];

  const columns = [
    {
      title: "Bill No",
      key: "1",
      dataIndex: "billNo",
      sorter: (a, b) => (a.billNo || "").localeCompare(b.billNo || ""),
    },
    {
      title: "Voided Date",
      key: "2",
      dataIndex: "voidedDate",
      render: (text) =>
        <span>{text ? dayjs(text).format("DD-MM-YYYY HH:mm") : ""}</span>,
      sorter: (a, b) => dayjs(a.voidedDate).valueOf() - dayjs(b.voidedDate).valueOf(),
    },
    {
      title: "Product",
      key: "3",
      dataIndex: "product",
      render: (text) => <span>{text?.name}</span>,
    },
    {
      title: "Quantity",
      key: "4",
      dataIndex: "quantity",
      sorter: (a, b) => a.quantity - b.quantity,
    },
    {
      title: "Rate",
      key: "5",
      dataIndex: "unitRate",
      render: (text) => <span>{Number(text ?? 0)?.toFixed(currfmt)}</span>,
      sorter: (a, b) => a.unitRate - b.unitRate,
    },
    {
      title: "Reason",
      key: "6",
      dataIndex: "reason",
    },
    {
      title: "Voided By",
      key: "7",
      dataIndex: "user",
      render: (text) => <span>{text?.name}</span>,
    },
    {
      title: "Section",
      key: "8",
      dataIndex: "section",
      render: (text) => <span>{text?.name}</span>,
    },
    {
      title: "Counter",
      key: "9",
      dataIndex: "counter",
      render: (text) => <span>{text?.name}</span>,
    },
    {
      title: "Branch",
      key: "10",
      dataIndex: "branch",
      render: (text) => <span>{text?.name}</span>,
    },
  ];

  const [selectedColumns, setSelectedColumns] = useState();

  useEffect(() => {
    const initialSelectedColumns = menuItems
      ?.filter((item) => item.checked)
      ?.map((item) => columns?.find((col) => col.key === item.value));
    setSelectedColumns(initialSelectedColumns);
  }, []);

  const handleCheckboxChange = (columnKey, checked) => {
    if (checked) {
      setSelectedColumns((prevColumns) => {
        const updatedColumns = [
          ...prevColumns,
          columns?.find((col) => col.key === columnKey),
        ];
        return updatedColumns.sort((a, b) => Number(a.key) - Number(b.key));
      });
    } else {
      setSelectedColumns((prevColumns) =>
        prevColumns?.filter((col) => col.key !== columnKey)
      );
    }
  };

  // The free-text box narrows the rows already on screen; the dropdowns above
  // re-query the server so paging stays accurate.
  const matchesSearch = (obj) => {
    if (!searchText) return true;
    const needle = searchText.toLowerCase();
    return (
      obj?.billNo?.toLowerCase().includes(needle) ||
      obj?.product?.name?.toLowerCase().includes(needle) ||
      obj?.reason?.toLowerCase().includes(needle) ||
      obj?.user?.name?.toLowerCase().includes(needle) ||
      obj?.section?.name?.toLowerCase().includes(needle)
    );
  };
  const modifiedList = voidData?.filter(matchesSearch);
  const modifiedallList = allData?.filter(matchesSearch);

  // The endpoint computes the quantity total server-side, so bind it directly
  // instead of re-summing client-side the way the older reports have to.
  const footerTotals = {
    quantity: footerTotal?.quantity,
  };

  const getActiveTabData = () => {
    const fieldMapping = {
      "Bill No": "billNo",
      "Voided Date": "voidedDateText",
      Product: "product.name",
      Quantity: "quantity",
      Rate: "unitRate",
      Reason: "reason",
      "Voided By": "user.name",
      Section: "section",
      Counter: "counter",
      Branch: "branch.name",
    };
    const data = modifiedallList?.map((row) => ({
      ...row,
      voidedDateText: row?.voidedDate
        ? dayjs(row.voidedDate).format("DD-MM-YYYY HH:mm")
        : "",
    }));
    return {
      data,
      columns: selectedColumns,
      fieldMapping,
      Rname: "Void Report",
      fromDate: dayjs(fromDate).format("MM/DD/YYYY"),
      toDate: dayjs(toDate).format("MM/DD/YYYY"),
    };
  };

  const handleSearchClick = () => {
    setCurrentPage(1);
    handlegetVoidReport(1, pageSize);
    handlegetVoidfullReport();
  };

  const handleReset = () => {
    setFromDate(dayjs());
    setToDate(dayjs());
    setSearchText("");
    setsectionval(null);
    setcounterval(null);
    setproductval(null);
    setuserval(null);
  };

  const handleRefresh = () => {
    handlegetVoidReport(currentPage, pageSize);
    handlegetVoidfullReport();
  };

  return (
    <div>
      <LoadingUtils loading={loading} />
      <div className="page-wrapper">
        <div className="content">
          <div className="page-header transfer">
            <div className="add-item d-flex">
              <div className="page-title">
                <h4>Void Report</h4>
              </div>
            </div>

            <ul className="table-top-head">
              <li>
                <OverlayTrigger placement="top" overlay={renderTooltip("PDF")}>
                  <button
                    onClick={() =>
                      exportreportPDF(
                        getActiveTabData,
                        footerTotals,
                        companyInfolist
                      )
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/pdf.svg"
                      alt="img"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Excel")}
                >
                  <button
                    onClick={() =>
                      exportreportExcel(
                        getActiveTabData,
                        footerTotals,
                        companyInfolist
                      )
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <ImageWithBasePath
                      src="assets/img/icons/excel.svg"
                      alt="excel-icon"
                    />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Print")}
                >
                  <button
                    onClick={() =>
                      printreportReport(
                        getActiveTabData,
                        footerTotals,
                        companyInfolist
                      )
                    }
                    disabled={loading}
                    className="btn btn-link bg-white rounded-lg border border-silver"
                  >
                    <i data-feather="printer" className="feather-printer" />
                  </button>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={() => renderTooltip("Refresh")}
                >
                  <Link onClick={handleRefresh}>
                    <RotateCcw />
                  </Link>
                </OverlayTrigger>
              </li>
              <li>
                <OverlayTrigger
                  placement="top"
                  overlay={renderTooltip("Collapse")}
                >
                  <Link
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    id="collapse-header"
                    className={togglehead ? "active" : ""}
                    onClick={handletogglehead}
                  >
                    <ChevronUp />
                  </Link>
                </OverlayTrigger>
              </li>
            </ul>
          </div>

          <div className="card table-list-card">
            <div className="card-body">
              <div className="table-top">
                <div className="search-set mt-2">
                  <div className="search-input">
                    <Link to="#" className="btn btn-searchset">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width={24}
                        height={24}
                        viewBox="0 0 24 24"
                        fill="none"
                        stroke="currentColor"
                        strokeWidth={2}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        className="feather feather-search"
                      >
                        <circle cx={11} cy={11} r={8} />
                        <line x1={21} y1={21} x2="16.65" y2="16.65" />
                      </svg>
                    </Link>
                    <div
                      id="DataTables_Table_0_filter"
                      className="dataTables_filter"
                    >
                      <label>
                        {" "}
                        <input
                          type="search"
                          className="form-control form-control-sm"
                          placeholder="Search"
                          aria-controls="DataTables_Table_0"
                          value={searchText}
                          onChange={handleSearch}
                        />
                      </label>
                    </div>
                  </div>
                </div>
                <div className="row">
                  <div className="col-md-6">
                    <div className="input-blocks">
                      <label htmlFor="from-date">From Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          className="datetimepicker"
                          id="from-date"
                          placeholder="From Date"
                          value={fromDate}
                          onChange={handleFromDateChange}
                        />
                      </div>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className="input-blocks mr-2">
                      <label htmlFor="to-date">To Date</label>
                      <div className="input-groupicon calender-input">
                        <Calendar className="info-img" />
                        <DatePicker
                          id="to-date"
                          placeholder="To Date"
                          value={toDate}
                          onChange={handleToDateChange}
                          minDate={fromDate}
                          disabled={!fromDate}
                        />
                      </div>
                    </div>
                  </div>
                </div>
                <div className="d-flex justify-content-end mt-4">
                  <div className="input-blocks me-2">
                    <Link
                      className="btn btn-filters ms-auto"
                      onClick={handleSearchClick}
                    >
                      <i data-feather="search" className="feather-search" />{" "}
                      search{" "}
                    </Link>
                  </div>
                  <div className="input-blocks">
                    <button
                      className="btn btn-reset rounded-2"
                      onClick={handleReset}
                    >
                      <i
                        data-feather="refresh-cw"
                        className="feather-refresh-cw"
                      />{" "}
                      Reset
                    </button>
                  </div>
                </div>
                <div className="search-path">
                  <Link
                    className={`btn btn-filter ${
                      isFilterVisible ? "setclose" : ""
                    }`}
                    id="filter_search"
                    onClick={toggleFilterVisibility}
                  >
                    <Filter className="filter-icon" />
                    <span onClick={toggleFilterVisibility}>
                      <ImageWithBasePath
                        src="assets/img/icons/closes.svg"
                        alt="img"
                      />
                    </span>
                  </Link>
                </div>

                <div className="dropdown">
                  <button
                    className="btn  dropdown-toggle"
                    type="button"
                    data-bs-toggle="dropdown"
                    aria-expanded="false"
                  >
                    <Sliders className="info-img" />
                  </button>
                  <ul className="dropdown-menu p-2">
                    {menuItems?.map((obj, i) => {
                      return (
                        <li key={i}>
                          <Checkbox
                            onChange={(e) =>
                              handleCheckboxChange(obj.value, e.target.checked)
                            }
                            defaultChecked={obj.checked}
                          >
                            <div style={{ color: "black" }}> {obj.label}</div>
                          </Checkbox>
                        </li>
                      );
                    })}
                  </ul>
                </div>
              </div>

              <div
                className={`card${isFilterVisible ? " visible" : ""}`}
                id="filter_inputs"
                style={{ display: isFilterVisible ? "block" : "none" }}
              >
                <div className="card-body pb-0">
                  <div className="row">
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Layers className="info-img" />
                        <Select
                          className="img-select"
                          options={product}
                          value={productval}
                          onChange={setproductval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Product"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <File className="info-img" />
                        <Select
                          className="img-select"
                          options={section}
                          value={sectionval}
                          onChange={setsectionval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Section"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <Archive className="info-img" />
                        <Select
                          className="img-select"
                          options={counter}
                          value={counterval}
                          onChange={setcounterval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Enter Counter"
                        />
                      </div>
                    </div>
                    <div className="col-lg-2 col-sm-6 col-12">
                      <div className="input-blocks">
                        <User className="info-img" />
                        <Select
                          className="img-select"
                          options={users}
                          value={userval}
                          onChange={setuserval}
                          isClearable
                          classNamePrefix="react-select"
                          placeholder="Voided By"
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* /Filter */}
              {selectedColumns && (
                <div className="table-responsive product-list">
                  <Table
                    className="table datanew dataTable no-footer custom-table"
                    columns={selectedColumns}
                    dataSource={modifiedList}
                    rowKey={(record, index) => index}
                    ref={tableRef}
                    id="table-to-export"
                    pagination={{
                      showTotal: (total, range) =>
                        `${range[0]}-${range[1]} of ${totalcount} items`,
                      current: currentPage,
                      pageSize: pageSize,
                      total: totalcount,
                      onChange: (page, size) => {
                        setCurrentPage(page);
                        setPageSize(size);
                        handlegetVoidReport(page, size);
                      },
                      showSizeChanger: true,
                      pageSizeOptions: ["10", "20", "50", "100"],
                    }}
                    summary={() => (
                      <Table.Summary.Row>
                        {selectedColumns?.map((col) => (
                          <Table.Summary.Cell key={col.key}>
                            <b>{footerTotals[col.dataIndex] ?? ""}</b>
                          </Table.Summary.Cell>
                        ))}
                      </Table.Summary.Row>
                    )}
                  />
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default VoidReport;
